import React from 'react';

import { Skeleton } from '@mui/material';
import { t } from 'i18next';

import ActionCard from './sections/ProtectionActionCard/ActionCard';
import BdsCardContainer from '../../../../../../shared/components/v3/Cards/BdsCardContainer/BdsCardContainer';
import ErrorCard from '../../../../../../shared/components/v3/Cards/ErrorCard/ErrorCard';
import { PERSON_MULTI, PROTECTION_ICON } from '../../../../../../shared/constants/images';
import { IActionCard } from '../../../../../../shared/interfaces/actionCard';
import { TRANSLATIONS_GLOBAL } from '../../../../../../shared/translations/commons';

import './ProtectionActionsCard.scss';

export interface IProtectionActionsCard {
  loading: boolean;
  error?: boolean;
  action?: () => void;
  data: IActionCard[];
  title: string;
}

const ProtectionActionsCard = ({ loading, data, title, error, action }: IProtectionActionsCard) => {
  if (loading) {
    return (
      <div className="protection-actions-skeleton-container">
        <Skeleton className="protection-actions-skeleton" variant="rectangular" />
      </div>
    );
  }

  const renderCardContent = (content: React.ReactNode) => {
    return (
      <BdsCardContainer
        type="solid"
        borderRadiusSize="radius-l"
        paddingSize="padding-l"
        className="protection-actions-card w-full flex flex-column"
        withMinWidth={false}
      >
        <h3 className="card-title w-full text-start">{t(title)}</h3>
        <div className="action-cards-container">{content}</div>
      </BdsCardContainer>
    );
  };

  if (error || !data.length) {
    return renderCardContent(
      <ErrorCard
        className="w-full flex flex-column justify-center text-start"
        primaryText={t(TRANSLATIONS_GLOBAL.errorCard.title)}
        secondaryText={t(TRANSLATIONS_GLOBAL.errorCard.description)}
        action={() => action?.()}
        buttonText={t(TRANSLATIONS_GLOBAL.errorCard.buttonText)}
      />
    );
  }

  const renderActionCards = () => {
    return data.map((cardItem, index) => (
      <ActionCard
        key={`action-card-${cardItem.description}`}
        description={cardItem.description}
        action={cardItem.action}
        leadingIcon={index === 0 ? PROTECTION_ICON : PERSON_MULTI}
        value={cardItem.value}
        extraPadding={index !== 0}
        insight={cardItem.insight}
      />
    ));
  };

  return renderCardContent(renderActionCards());
};

export default ProtectionActionsCard;
